export interface RelabellingFlags {
  uk: boolean;
  eu: boolean;
}

/**
 * Reads UK/EU relabelling flags off a product, defaulting either to `false`
 * when absent.
 */
export const resolveRelabellingFlags = (product: {
  requiresUkRelabelling?: boolean;
  requiresEuRelabelling?: boolean;
}): RelabellingFlags => ({
  uk: product.requiresUkRelabelling ?? false,
  eu: product.requiresEuRelabelling ?? false
});
